import { DropDown } from './DropDownDto';

export interface DropDownActive extends DropDown {
  bActive: boolean;
}
